<!--
    @修改人：黎柏祺
    @修改时间：2018-12-18
    @修改描述：框架升级
    @版本:v1.0.26
    ------------
    @负责人: 邱凤云
    @创建时间: 2018-01-18
    @版本:v1.0.12
    @描述: 应用日志路由页面
-->
<template>
  <div class="appLogRouteConfig__content">
    <el-form ref="form" :model="form" :inline="true" input-width="auto">  
      <el-form-item :label="$t('logComponentManage.group')">
        <g-select :list="groupList" v-model="form.group" :default-all="true" ></g-select>
      </el-form-item>
      <el-form-item :label="$t('logComponentManage.appName')">
        <g-select :list="selectAppList" v-model="form.appName" :default-all="true"></g-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="e_search" v-g-rac="gRac('appLogRouteConfig_search')">{{ $t('common.search') }}</el-button>
        <el-button type="primary" @click="e_add()" v-g-rac="gRac('appLogRouteConfig_add')">{{ $t('logComponentManage.add') }}</el-button>
      </el-form-item>
    </el-form>
    <el-table-extend 
      :data="tData" 
      :head="tHead" 
      :currentChange="tCurrentChange" 
      :sizeChange="tSizeChange" 
      border>
      <template slot="control-column" slot-scope="{data}">
        <el-table-extend-control 
          :control="tableControl" 
          :data="data" 
          :label="$t('common.handle')">
        </el-table-extend-control>
      </template>
    </el-table-extend>
    <el-dialog :closeOnClickModal="false" :title="dialogTitle" :visible.sync="dialogFormShow" width="700px">
      <el-form :model="routeForm" label-position="right" label-width="120px" ref="routeForm" :rules="dialogFormRule">
        <el-form-item :label="$t('logComponentManage.group')" prop="group">
          <g-select :list="groupList" v-model="routeForm.group" :tdisabled="readOnly"></g-select>
        </el-form-item>
        <el-form-item :label="$t('logComponentManage.appName')">
          <g-select :list="selectAppListForAdd" v-model="routeForm.appName" :default-all="true" :tdisabled="readOnly" v-show="!isAmend"></g-select>
          <el-input v-model="routeForm.appName2" :disabled="read" v-show="isAmend"></el-input>
        </el-form-item>
        <el-form-item :label="$t('logComponentManage.mqType')" >
          <el-input v-model="routeForm.mqType" :disabled="read" ></el-input>
        </el-form-item>
        <el-form-item :label="$t('logComponentManage.brokerList')" >
          <el-input v-model="routeForm.brokerList"></el-input>
        </el-form-item>
        <el-form-item :label="$t('logComponentManage.reserve')" >
          <el-input v-model="routeForm.reserve"></el-input>
        </el-form-item>
        <el-form-item input-width="550px" :label="$t('logComponentManage.config')">
          <dynamic-table ref="dynamicTable" 
            :input-data="inputData" 
            :model="tableModel" 
            :custom-fun="deleteDdata">
          </dynamic-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="e_cancel">{{$t('common.cancel')}}</el-button>
        <el-button type="primary" @click="e_save">{{$t('common.save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
        
<script >
  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import table from '@/components/mixins/table'
  import systemSettingBiz from '@/logic/systemSetting/systemSettingBiz.js'
  import dialogForm from '@/components/dialogForm'
  import validateConfig from '@/utils/validate'
  import dynamicTable from '@/components/dynamicTable.vue'
  import { extend, getKeyByValue } from '@/utils/tool'
  export default {
    mixins: [rac, dic, table],
    components: {
      dialogForm,
      dynamicTable
    },
    props: ['siteCode'],
    data () {
      const that = this
      return {
        form: {
          group: '',
          appName: ''
        },
        routeForm: {
          group: '',
          appName: '',
          brokerList: '',
          reserve: '',
          mqType: 'KAFKA'
        },
        select_enable: {
          true: that.$t('logComponentManage.beUse'),
          false: that.$t('logComponentManage.stopUse')
        },
        selectAppListForAdd: {},
        selectAppList: {},
        tableControl: [
          {
            label: that.$t('common.edit'),
            callback: that.e_add,
            rac: () => that.gRac('appLogRouteConfig_amend')
          }, {
            label: that.$t('common.delete'),
            callback: that.e_delete,
            rac: () => that.gRac('appLogRouteConfig_delete')
          }
        ],
        dialogFormShow: false,
        dialogTitle: '',
        dialogData: [],
        dialogModel: {},
        dialogFormRule: {
          group: [{ ...validateConfig.common.notEmpty }]
        },
        inputData: [],
        tableModel: {},
        isAmend: false,
        topicListNew: {},
        readOnly: false,
        read: true,
        init: true,
        groupList: {}
      }
    },
    computed: {
    },
    methods: {
      async waitAppList (group, val) {
        await this.$store.dispatch('resetAppByGroup', {
          siteCode: this.siteCode,
          group: group
        })
        // await this.dGetAppByGroup(this.siteCode, group)
        if (val === 1) {
          this.selectAppList = { ...this.dDictionaryApp[group] }
          this.form.appName = ''
        } else {
          this.selectAppListForAdd = { ...this.dDictionaryApp[group] }
          this.routeForm.appName = ''
        }
      },
      async preInitTable () {
        await Promise.all([
          this.dGetGroup(this.siteCode, true),
          this.dGetDictionaryByCode('logLevel'),
          systemSettingBiz.getTopic().then((data) => {
            data.map((item) => { this.topicListNew[item.topic] = item.topic })
          })
        ])
        this.groupList = this.$store.state.dicModule.group
        this.initTable()
        this.setDynamicData()
      },
      e_search () {
        this.tResetPage()
        this.search()
      },
      initTable () {
        this.tInitTable({
          lanKey: 'logComponentManage.table',
          head: ['group', 'appName', 'mqType', 'brokerList', 'reserve'],
          requestFun: this.search,
          headOpt: {
            group: {
              formatter: 'Dictionary',
              formatterDic: this.groupList
            }
          }
        })
      },
      setDynamicData () {
        this.inputData = [
          {
            label: this.$t('logComponentManage.key'),
            key: 'logKey'
          },
          {
            label: this.$t('logComponentManage.topic'),
            key: 'topic',
            type: 'select',
            select: this.topicListNew
          }
        ]
        this.tableModel = {
          logKey: '',
          topic: Object.keys(this.topicListNew)[0]
        }
      },
      search () {
        const reqData = extend(true, { ...this.tPageInfo }, this.form)
        let params = new URLSearchParams()
        Object.keys(reqData).map((item) => { params.append(item, reqData[item]) })
        params.append('siteCode', this.siteCode)
        systemSettingBiz.getRoute(params).then((data) => {
          this.tData = data
        }).catch((err) => {
          console.error(err)
        })
      },
      e_add (rowData) {
        this.dialogFormShow = true
        this.isAmend = rowData !== undefined
        this.dialogTitle = rowData !== undefined ? this.$t('logComponentManage.change') : this.$t('logComponentManage.add')
        this.readOnly = rowData !== undefined
        this.$nextTick(() => {
          if (rowData) {
            let tableData = []
            Object.keys(rowData.config).map((item) => { tableData.push(rowData.config[item]) })
            this.$refs.dynamicTable.setData(tableData)
            this.routeForm = {
              group: getKeyByValue(this.groupList, rowData.group),
              appName: rowData.appName,
              appName2: rowData.appName,
              brokerList: rowData.brokerList,
              reserve: rowData.reserve,
              mqType: rowData.mqType,
              id: rowData.id
            }
          } else {
            this.$refs.dynamicTable.setData([])
            this.routeForm = {
              group: '',
              appName: '',
              brokerList: '',
              reserve: '',
              mqType: 'KAFKA'
            }
          }
        })
      },
      e_cancel () {
        this.dialogFormShow = false
      },
      e_save () {
        const reqData = extend(true, {}, this.routeForm)
        reqData.siteCode = this.siteCode
        reqData.config = {}
        const tableData = this.$refs.dynamicTable.getData()
        tableData.map((item) => { reqData.config[item.logKey] = item })
        this.$refs.routeForm.validate((valid) => {
          if (valid) {
            if (this.isAmend) {
              reqData.appName = reqData.appName2
              delete reqData.appName2
              systemSettingBiz.changeRoute(reqData).then(() => {
                this.$message({
                  message: this.$t('common.success'),
                  type: 'success'
                })
                setTimeout(() => {
                  this.dialogFormShow = false
                  this.e_search()
                }, 500)
              })
            } else {
              delete reqData.appName2
              systemSettingBiz.addRoute(reqData).then(() => {
                this.$message({
                  message: this.$t('common.success'),
                  type: 'success'
                })
                setTimeout(() => {
                  this.dialogFormShow = false
                  this.e_search()
                }, 500)
              })
            }
          }
        })
      },
      e_delete (rowData) {
        let params = new URLSearchParams()
        params.append('id', rowData.id)
        params.append('siteCode', this.siteCode)
        this.$confirm(this.$t('common.deleteTips'), this.$t('common.tips'), {
          type: 'warning'
        }).then(() => {
          systemSettingBiz.deleteRoute(params).then((data) => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            this.search()
          })
        }).catch(() => {
  
        })
      },
      deleteDdata (item, i) {
        const d = this.$refs.dynamicTable.getData()
        d.splice(i, 1)
        this.$refs.dynamicTable.setData(d)
      }
    },
    mounted () {},
    watch: {
      'form.group' () {
        this.waitAppList(this.form.group, 1)
      },
      'routeForm.group' () {
        this.waitAppList(this.routeForm.group, 2)
      },
      'siteCode' () {
        if (this.init) {
          this.init = false
          this.preInitTable()
          this.e_search()
        } else {
          this.e_search()
        }
      }
    }
  }
</script>
        
        
        
        
        
        
        
        